require('./myProfileKeysSignatureView.scss');
// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
import { i18n } from 'core/i18n';
const { formatText, getFinalTitle, getLanguage } = i18n
const PropTypes = require('prop-types');
// @ actions
const myProfileKeysSignatureActions = require('actions/myProfileKeysSignature');
//@ components
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const MyProfileKeysSignature = require('components/myProfile/myProfileKeysSignature/myProfileKeysSignature');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
// @ constants
const { FAQ_URL } = require('constants/links');
const { GRAPHIC_TUTOR_TYPE_4, REGENERATE_SIGNATURE_HIGH_BIOCATCH_SCORE } = require('constants/index');
const { REGENERATE_SIGNATURE_KEY_WITH_BIOCATCH } = require('constants/flagBasedFeatures.js');
import { MY_PROFILE_KEY_SIGNATURE_VIEW_STEP_EVENT } from 'constants/tagging';

// @utils
import { recordLinkV2 } from 'utilities/tagging';

class MyProfileKeysSignatureView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleRetryProcess = this.handleRetryProcess.bind(this);
    }

    componentDidMount() {
        const {
            immFlagBasedFeatures,
            getBiocatchScore
        } = this.props;
        this.props.reset();
        immFlagBasedFeatures.get(REGENERATE_SIGNATURE_KEY_WITH_BIOCATCH) && getBiocatchScore();
        this.props.requestSignatureKeyData();
        recordLinkV2({
            idioma: getLanguage(),
            pasoProceso: MY_PROFILE_KEY_SIGNATURE_VIEW_STEP_EVENT
        });
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.requestSignatureKeyData();
    }

    handleCancel() {
        const redirectUrl = __CONTACT_CENTER__ ? '/myprofile' : '/myprofile/keys';
        this.props.history.push(redirectUrl);
    }

    handleFinish() {
        this.props.postChange();
    }

    handleRetryProcess() {
        const { immMyProfileKeysSignature, retryProccess } = this.props;
        immMyProfileKeysSignature.get('retriesLeft') ? retryProccess() : this.props.history.push('/myprofile/keys');
    }

    render() {
        const {
            immFlagBasedFeatures,
            immMyProfileKeysSignature,
            immVariables,
            validateStep,
            setVisibleStep,
            setWillCancel,
            updateFirstField,
            updateSecondField,
            requestSignatureKeyData
        } = this.props;
        const mappingBreadcrumb = [
            ...(!__CONTACT_CENTER__ ? [
                {
                    text: formatText('profileKeysLanding-title'),
                    url: '/myprofile/keys'
                }
            ] : []),
            {
                text: formatText('signatureEdit-title'),
                url: ''
            }
        ];
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-profileKeySignatureTitle')}
                subtitle={formatText('tutorials-profileKeySignatureSubtitle')}
            />
        );
        const boxBody = ['signatureEdit-boxBody1', 'signatureEdit-boxBody2', 'signatureEdit-boxBody3'];
        const lowBiocatchAvailable = immFlagBasedFeatures.get(REGENERATE_SIGNATURE_KEY_WITH_BIOCATCH) ? immMyProfileKeysSignature.get('biocatchScore') : REGENERATE_SIGNATURE_HIGH_BIOCATCH_SCORE;
        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                tutorial={tutorial}
                                finalTitle={getFinalTitle('signatureEdit-title')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12 col-md-8">
                                <div className="row">
                                    <div className="col-md-12">
                                        <MyProfileKeysSignature
                                            lowBiocatchAvailable={lowBiocatchAvailable}
                                            immFlagBasedFeatures={immFlagBasedFeatures}
                                            immMyProfileKeysSignature={immMyProfileKeysSignature}
                                            requestSignatureKeyData={requestSignatureKeyData}
                                            immVariables={immVariables}
                                            validateStep={validateStep}
                                            setVisibleStep={setVisibleStep}
                                            setWillCancel={setWillCancel}
                                            updateFirstField={updateFirstField}
                                            updateSecondField={updateSecondField}
                                            onFinish={this.handleFinish}
                                            onRetryFailure={this.handleRetryProcess}
                                            onCancel={this.handleCancel}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-4">
                                <div className="row">
                                    <div className="col-xs-12 grid-view--variable-cell-separation">
                                        <ContactInfoBox
                                            boxTitle={formatText('signatureEdit-boxTitle')}
                                            boxBody={boxBody}
                                            linkText1={formatText("profileKeysLanding-sideText1")}
                                            linkText2={formatText("profileKeysLanding-sideText2")}
                                            linkURL={FAQ_URL}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MyProfileKeysSignatureView.propTypes = {
    cancel: PropTypes.func.isRequired,
    history: PropTypes.object,
    failureRetry: PropTypes.func.isRequired,
    getBiocatchScore: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    immMyProfileKeysSignature: PropTypes.object,
    immSteps: PropTypes.object,
    immVariables: PropTypes.object.isRequired,
    postChange: PropTypes.func.isRequired,
    requestSignatureKeyData: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    retryProccess: PropTypes.func.isRequired,
    setField: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    updateFirstField: PropTypes.func.isRequired,
    updateSecondField: PropTypes.func.isRequired
};

module.exports.constructor = MyProfileKeysSignatureView;
module.exports.MyProfileKeysSignatureView = connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
        immMyProfileKeysSignature: state.myProfileKeysSignature,
        immVariables: state.globalVariables.getIn(['variables', 'parameters']),
    }),
    {
        getBiocatchScore: myProfileKeysSignatureActions.getBiocatchScore,
        postChange: myProfileKeysSignatureActions.postChange,
        reset: myProfileKeysSignatureActions.reset,
        requestSignatureKeyData: myProfileKeysSignatureActions.requestSignatureKeyData,
        retryProccess: myProfileKeysSignatureActions.retryProccess,
        setField: myProfileKeysSignatureActions.setField,
        setVisibleStep: myProfileKeysSignatureActions.setVisibleStep,
        setWillCancel: myProfileKeysSignatureActions.setWillCancel,
        validateStep: myProfileKeysSignatureActions.validateStep,
        updateFirstField: myProfileKeysSignatureActions.updateFirstField,
        updateSecondField: myProfileKeysSignatureActions.updateSecondField
    }
)(withRouter(MyProfileKeysSignatureView));
